$(document).ready(function () {
	let $formOrder = $("#form-constructor-order");

	$formOrder.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();
		let $btn = $(this).find('button[type=submit]');
		let $messages = $(this).find('.messages');

		let previousText = $btn.text();
		$btn.text('Оформляем заказ...').attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				$btn.text(previousText).removeAttr('disabled');
				$messages.find('.msg-error').text(data.msg).show();

			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});
		
		return false;
	});

	let hash = location.hash;
	if (hash) {
		if (/order\-\d+/.test(hash)) {
			let match = location.hash.match(/\d+/);
			if (typeof match[0] !== 'undefined') {
				$.get('/orders/modal', {id: match[0]}, function (data) {
					if (data.view) {
						$('.ajax-modals').append(data.view);
						$('.ajax-modals .modal').last().modal('show');
					}
				});
			}
		}
	}
});